import React from "react";
import Specialtie from "./Specialtie";

const Specialties = () => {
  const specialties = [
    {
      name: "Nature Photography",
      description: "Aenean lacinia consectetur donec ullamcorper at nulla.",
      img: "https://demos.elemisthemes.com/juno8/style/images/art/s1.jpg",
    },
    {
      name: "Conceptual Photography",
      description: "Aenean lacinia consectetur donec ullamcorper at nulla.",
      img: "https://demos.elemisthemes.com/juno8/style/images/art/s2.jpg",
    },
    {
      name: "Food & Drink Photography",
      description: "Aenean lacinia consectetur donec ullamcorper at nulla.",
      img: "https://demos.elemisthemes.com/juno8/style/images/art/s3.jpg",
    },
    {
      name: "Portrait Photography",
      description: "Aenean lacinia consectetur donec ullamcorper at nulla.",
      img: "https://demos.elemisthemes.com/juno8/style/images/art/s4.jpg",
    },
  ];
  return (
    <div>
      <div className="font-serif items-center text-center mt-10 mb-5">
        <h1 className="text-3xl font-bold  text-black">My Specialties</h1>
        <p className="text-xl">
          Integer posuere erat a ante venenatis dapibus posuere velit aliquet.{" "}
          <br />
          Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.
        </p>
      </div>
      <div className="grid gap-10 row-gap-10 sm:grid-cols-1 lg:grid-cols-2 px-4 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        {specialties.map((specialty, i) => (
          <Specialtie key={i} specialty={specialty} />
        ))}
      </div>
    </div>
  );
};

export default Specialties;
